import { makeStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles(({ breakpoints }: Theme) => ({
  photo: {
    [breakpoints.down(1024)]: {
      display: 'none',
    },
  },
  efoImage: {
    position: 'absolute',
    left: 90,
    top: 21,
  },
  photoMobile: {
    display: 'none',
    [breakpoints.down(1024)]: {
      display: 'block',
      '& img': {
        width: 60,
        height: 'auto',
      },
    },
    [breakpoints.down(500)]: {
      '& img': {
        width: 109,
        height: 'auto',
      },
    },
  },
}));
